import { useQuery } from "@tanstack/react-query";
import { ScheduleClient } from "../../web-api-client"; // NSwag client
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { wrapFetchWithSignal } from "../../utils/abort";
import { appConfig } from "../../appconfig";

function todmY(d?: Date) {
  if (!d) return undefined;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}/${m}/${y}`;
}

/** Hook lấy danh sách lịch theo filter */
export function useSchedules(params: { clinicId?: number; doctorId?: string; fromDate: Date; toDate: Date; enabled?: boolean }) {
  const { clinicId, doctorId, fromDate, toDate, enabled = true } = params || {};

  return useQuery({
    queryKey: ["schedules", { clinicId, doctorId, fromDate: todmY(fromDate), toDate: todmY(toDate) }],
    enabled,
    queryFn: async ({ signal }) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: wrapFetchWithSignal(fetchWithTimeout(), signal),
      });

      const data = await client.getSchedules(clinicId, doctorId, todmY(fromDate) ?? "", todmY(toDate) ?? "");
      return (data ?? []);
    },
    staleTime: 60_000, // 1 phút
    refetchOnWindowFocus: false,
    retry(failureCount, error: any) {
      if (error?.name === "AbortError") return false;
      return failureCount < 2;
    },
  });
}
